/* workspace-admin/CustomObjectsAdmin — CRM Configuration > Custom Objects.
   Renders the workspace-scoped Custom Objects manager (CustomObjectsManagerView)
   inside the Workspace Admin console. Wraps with WorkspaceRuntimeProvider so the
   manager's useWorkspace() hook resolves the correct wsId from the admin route
   param instead of the session's activeWorkspaceId. */
import React from 'react';
import { useParams } from 'react-router-dom';
import { findWorkspace } from '../platform/platformStore';
import { WorkspaceRuntimeProvider } from '../workspace/WorkspaceRuntimeContext.jsx';

export default function CustomObjectsAdmin({ data }) {
  const { wsId } = useParams();
  const ws = findWorkspace(data.state, wsId);
  if (!ws) return null;

  const ManagerView = window.CustomObjectsManagerView;
  if (!ManagerView) {
    return (
      <div className="nx-cc-page">
        <div className="nx-empty" style={{ marginTop: 60 }}>
          <span>Custom Objects manager loading…</span>
        </div>
      </div>
    );
  }

  return (
    <WorkspaceRuntimeProvider workspaceId={wsId}>
      <div className="nx-cc-page" style={{ padding: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100%' }}>
        <ManagerView />
      </div>
    </WorkspaceRuntimeProvider>
  );
}
